export async function doOauthLogin(code, api) {
  try {
    let res = await api.post("/oauth-login/flo-mso", {
      oauth_code: code,
      redirect_uri: window.location.origin
    });
    if (res && res.token) {
      return res.token;
    }
  } catch (e) {
    console.info("OAuth login failed", e);
  }
  return null;
}

export async function initOauthLogin(floOauth) {
  if (!floOauth) {
    console.info("No OAuth configuration found");
    return;
  }

  let redirectUri = window.location.origin;

  let url = floOauth["loginUrl"];
  let query = [
    "client_id=" + floOauth["clientId"],
    "redirect_uri=" + redirectUri,
    "response_type=code",
    "scope=" + floOauth["scope"]
  ];

  window.location.href =
    url + (url.includes("?") ? "&" : "?") + query.join("&");
}
